<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box unique-report-card pb-4">

            <v-toolbar class="toolbar no-display elevation-1 mb-2" flat dense color="white">
                <v-toolbar-title>
                    <span class="font-weight-bold slate--text">
                        Subject Wise Student Report
                    </span>
                </v-toolbar-title>
            </v-toolbar>

            <v-row justify="center" dense class="no-display mx-2 pt-4 ml-10">

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error" small class="mr-1">*</v-icon>

                    <v-autocomplete color="indigo" dense rounded outlined required v-model="selected_ay"
                        :items="ay_list" item-text="ay" item-value="id" label="Select Academic Year" persistent-hint
                        hint="Please Select Academic Year" @change="clearOfferingSelection" />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error" small class="mr-1">*</v-icon>

                    <v-autocomplete color="indigo" dense rounded outlined required v-model="selected_standard"
                        :items="standard_list" item-text="standard" item-value="id" label="Please Select Standard"
                        persistent-hint hint="Please Select Standard" @change="clearOfferingSelection" />
                </v-col>

                <v-col cols="12" sm="2" md="2">
                    <v-btn class="mt-7 action-fetch-btn" color="indigo" dark small rounded :loading="fetch_loader"
                        @click="getreport">
                        Fetch
                    </v-btn>
                </v-col>

            </v-row>

            <v-row v-if="flattenedReport && flattenedReport.length" justify="center" align="center" dense
                class="no-display mt-4 mx-2">
                <v-col cols="12" sm="5" md="5">
                    <v-icon color="error" small class="mr-1">*</v-icon>

                    <v-autocomplete color="indigo" dense outlined clearable return-object v-model="selected_offering"
                        :items="flattenedReport" item-text="item_name" item-value="sr_no"
                        label="Select Subject" persistent-hint hint="Please Select Subject" multiple
                        chips small-chips />
                </v-col>

                <v-col cols="12" sm="2" md="2" class="mb-4 pl-2 mt-3">
                    <v-btn color="success" dark small rounded :loading="get_loader"
                        :disabled="!selected_offering || !selected_offering.length" @click="getStudentsReport">
                        Get Students
                    </v-btn>
                </v-col>
            </v-row>

            <div v-if="students_lists && students_lists.length" class="mx-6 mt-6">
                <v-divider class="mb-4"></v-divider>

                <div class="mb-4 generic-summary-container p-3 grey lighten-4 rounded">
                    <div class="text-subtitle-2 font-weight-bold grey--text text--darken-3 mb-2">
                        Subject Selected Students List:
                    </div>
                    <v-row dense>
                        <v-col cols="12" class="d-flex flex-wrap align-center">
                            <v-chip v-for="(subject, idx) in subjectSummaries" :key="idx"
                                class="ma-1 font-weight-medium" color="indigo lighten-5" text-color="indigo darken-3"
                                label>
                                {{ subject.name }} : <strong>&nbsp;{{ subject.count }}</strong>
                            </v-chip>

                            <v-spacer></v-spacer>

                            <v-chip color="grey darken-3" dark class="ma-1 font-weight-bold" label>
                                Showing: {{ filteredStudents.length }} / {{ total_count }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </div>

                <v-row dense class="mb-4" align="center">
                    <v-col cols="12" sm="4" md="4">
                        <v-select 
                            v-model="filter_subject" 
                            :items="availableFilterSubjects" 
                            label="Filter Table by Subject" 
                            outlined 
                            dense 
                            clearable 
                            hide-details
                            prepend-inner-icon="mdi-filter-variant"
                            color="indigo"
                        ></v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="auto" class="d-flex gap-2">
                        <v-btn color="green darken-2" dark small rounded class="mr-2" @click="exportToExcel">
                            <v-icon left small>mdi-file-excel</v-icon> Export Excel
                        </v-btn>
                        <v-btn color="red darken-2" dark small rounded @click="exportToPDF">
                            <v-icon left small>mdi-file-pdf-box</v-icon> Export PDF
                        </v-btn>
                    </v-col>
                </v-row>

                <div class="printing_area">
                    <v-simple-table dense class="custom-designed-table elevation-1">
                        <thead>
                            <tr>
                                <th class="text-center text-no-wrap" style="width: 6%">
                                    Sr No.
                                </th>
                                <th class="text-left text-no-wrap" style="width: 16%; padding-left:15px;">
                                    PRN
                                </th>
                                <th class="text-left text-no-wrap" style="width: 30%; padding-left:15px;">
                                    Student Name
                                </th>
                                <th class="text-left text-no-wrap" style="width: 26%; padding-left:15px;">
                                    Subject Name
                                </th>
                                 <th class="text-left text-no-wrap" style="width: 12%; padding-left:15px;">
                                    Standard
                                </th>
                                 <th class="text-left text-no-wrap" style="width: 10%; padding-left:15px;">
                                    Division
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(stu, index) in filteredStudents" :key="index" class="table-row-hover">
                                <td class="text-center sr-num-col">
                                    {{ index + 1 }}
                                </td>
                                <td class="text-left prn-text-col" style="padding-left:15px !important;">
                                    {{ stu.learner_prn }}
                                </td>
                                <td class="text-left name-text-col" style="padding-left:15px !important;">
                                    {{ stu.learner_name }}
                                </td>
                                <td class="text-left" style="
                                    padding-left:15px !important;
                                    white-space: normal !important;
                                    word-break: break-word !important;
                                    line-height:1.4;
                                ">
                                    {{ stu.subject_names }}
                                </td>
                                <td class="text-left" style="padding-left:15px !important;">
                                    {{ stu.standard }}
                                </td>
                                <td class="text-left" style="padding-left:15px !important;">
                                    {{ stu.division }}
                                </td>
                            </tr>
                            <tr v-if="filteredStudents.length === 0">
                                <td colspan="6" class="text-center grey--text py-4">
                                    No records match the selected subject filter.
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </div>

        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

export default {

    data() {
        return {
            snackbar: false,
            snackbar_msg: "",
            color: "",

            fetch_loader: false,
            get_loader:false,

            ay_list: [],
            standard_list: [],
            report_data: [],
            students_lists: [],
            total_count: 0,

            selected_ay: "",
            selected_standard: "",
            selected_offering: [],

            filter_subject: null, 

            headers: [
                { text: 'Sr No.', value: 'sr_no', width: '6%' },
                { text: 'PRN', value: 'learner_prn', width: '16%' },
                { text: 'Student Name', value: 'learner_name', width: '30%' },
                { text: 'Subject Name', value: 'subject_names', width: '26%' },
                { text: 'Standard', value: 'standard', width: '12%' },
                { text: 'Division', value: 'division', width: '10%' }
            ]
        };
    },

    computed: {

        flattenedReport() {
            if (!this.report_data.length)
                return [];

            let list = [];
            list.push({
                sr_no: 0,
                raw_id: 0,
                selection_type: "ALL",
                item_name: "All"
            });

            this.report_data.forEach((row, index) => {
                list.push({
                    sr_no: index + 1,
                    raw_id: row.coff_id,
                    selection_type: "Subject",
                    item_name: row.subject
                });
            });

            return list;
        },

        filteredStudents() {
            let result = this.students_lists;

            if (this.filter_subject) {
                result = result.filter(student =>
                    student.co_off === this.filter_subject
                );
            }

            return [...result].sort((a, b) => {
                const prnCompare = String(a.learner_prn).localeCompare(
                    String(b.learner_prn),
                    undefined,
                    { numeric: true }
                );

                if (prnCompare !== 0) return prnCompare;

                return String(a.learner_name).localeCompare(String(b.learner_name));
            });
        },

        // subjectSummaries() {
        //     if (!this.students_lists || !this.students_lists.length) return [];

        //     const mapping = {};
        //     this.students_lists.forEach(student => {
        //         const name = student.subject_names || 'N/A';
        //         if (!mapping[name]) {
        //             mapping[name] = 0;
        //         }
        //         mapping[name]++;
        //     });

        //     return Object.keys(mapping).map(key => ({
        //         name: key,
        //         count: mapping[key]
        //     }));
        // },

        // availableFilterSubjects() {
        //     return this.subjectSummaries.map(item => item.name);
        // },

        // filteredStudents() {
        //     if (!this.filter_subject) {
        //         return this.students_lists;
        //     }
        //     return this.students_lists.filter(student => 
        //         student.subject_names && student.subject_names === this.filter_subject
        //     );
        // }

        subjectSummaries() {
            if (!this.students_lists || !this.students_lists.length) return [];

            const mapping = {};
            this.students_lists.forEach(student => {
                const key = `${student.subject_names}_${student.co_off}`;
                if (!mapping[key]) {
                    mapping[key] = {
                        name: student.subject_names,
                        co_off: student.co_off,
                        count: 0
                    };
                }
                mapping[key].count++;
            });

            return Object.values(mapping);
        },

        availableFilterSubjects() {
            return this.subjectSummaries.map(item => ({
                text: `${item.name}`,
                value: item.co_off
            }));
        },

        // filteredStudents() {
        //     if (!this.filter_subject) {
        //         return this.students_lists;
        //     }
        //     return this.students_lists.filter(student => 
        //         student.co_off === this.filter_subject
        //     );
        // }

    },

    mounted() {
        this.onload();
    },

    methods: {

        onload() {
            axios.post("/QuizScheduling/getAllData")
                .then(res => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;
                        // this.standard_list = res.data.standard_list;
                        this.standard_list = res.data.standard_list.filter(item => item.standard !== "All");
                    }
                });
        },

        clearOfferingSelection() {
            this.selected_offering = [];
            this.students_lists = [];
            this.total_count = 0;
            this.filter_subject = null; 
        },

        getreport() {
            if (!this.selected_ay || !this.selected_standard) {
                this.showSnackbar("error", "Select Academic Year and Standard.");
                return;
            }
            this.fetch_loader = true;
            axios.post("/admission/getSubjectsAndGroupsList", {
                academicyear_id: this.selected_ay,
                standard_id: this.selected_standard
            })
                .then(res => {
                    this.fetch_loader = false;
                    if (res.data.flag == "YES") {
                        this.report_data = res.data.subjectlist;
                    } else {
                        this.report_data = [];
                        this.showSnackbar("error", "No Subjects Found.");
                    }
                })
                .catch(() => {
                    this.fetch_loader = false;
                    this.showSnackbar("error", "Something went wrong.");
                });
        },

        getStudentsReport() {
            if (!this.selected_offering || !this.selected_offering.length) {
                this.showSnackbar("error", "Please select at least one subject.");
                return;
            }

            this.get_loader = true;
            this.filter_subject = null; 
            let targetIds = [];

            if (this.selected_offering.some(item => item.raw_id === 0)) {
                targetIds = this.report_data.map(row => row.coff_id);
            } else {
                targetIds = this.selected_offering.map(item => item.raw_id);
            }

            const payload={
                coff_ids: targetIds,
                academicyear_id: this.selected_ay,
                standard_id: this.selected_standard
            }

            axios.post("/admission/getSubjectRegisteredStudents", payload)
                .then((res) => {
                    this.get_loader = false;
                    if (res.data.flag == "YES") {
                        this.students_lists = res.data.studentList;
                        this.total_count = res.data.totalCount || res.data.studentList.length;

                        if(this.students_lists.length <= 0){
                            this.showSnackbar("error", "No Students Found For Selected Criteria");
                        }
                    } else {
                        this.students_lists = [];
                        this.total_count = 0;
                        this.showSnackbar("error", res.data.msg);
                    }
                })
                .catch((err) => {
                    this.get_loader = false;
                    console.log(err);
                    this.showSnackbar("error", "Failed to compile multi-subject data.");
                });
        },

        exportToExcel() {
            if (!this.filteredStudents.length) {
                this.showSnackbar("error", "No data available to export.");
                return;
            }

            const reportRows = this.filteredStudents.map((stu, index) => ({
                "Sr No.": index + 1,
                "PRN": stu.learner_prn || 'N/A',
                "Student Name": stu.learner_name || 'N/A',
                "Subject Name": stu.subject_names || 'N/A',
                "Standard": stu.standard || 'N/A',
                "Division": stu.division || 'N/A'
            }));

            const worksheet = XLSX.utils.json_to_sheet(reportRows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Students Report");

            XLSX.writeFile(workbook, `Student_Subject_Report_${Date.now()}.xlsx`);
        },

        exportToPDF() {
            if (!this.filteredStudents.length) {
                this.showSnackbar("error", "No data available to export.");
                return;
            }

            const doc = new jsPDF({ orientation: "landscape" });

            doc.setFontSize(14);
            doc.text("Subject Registered Students Report", 14, 15);

            const summaryMapping = {};
            this.filteredStudents.forEach(stu => {
                const name = stu.subject_names || "N/A";
                summaryMapping[name] = (summaryMapping[name] || 0) + 1;
            });

            const summaryRows = Object.keys(summaryMapping).map(key => [
                key,
                summaryMapping[key]
            ]);

            const half = Math.ceil(summaryRows.length / 2);

            const showSecondTable = summaryRows.length > 10;

            const leftRows = showSecondTable
                ? summaryRows.slice(0, half)
                : summaryRows;

            const rightRows = showSecondTable
                ? summaryRows.slice(half)
                : [];

            const startY = 26;

            doc.autoTable({
                head: [["Subject Name", "Count"]],
                body: leftRows,
                startY,
                margin: { left: 14 },
                tableWidth: 120,
                theme: "striped",
                styles: { fontSize: 7, cellPadding: 2 },
                headStyles: {
                    fillColor: [63, 81, 181],
                    textColor: 255,
                    fontStyle: "bold"
                },
                columnStyles: {
                    0: { cellWidth: 85 },
                    1: { cellWidth: 25 }
                }
            });

            let finalSummaryY = doc.lastAutoTable.finalY;

            if (showSecondTable) {
                doc.autoTable({
                    head: [["Subject Name", "Count"]],
                    body: rightRows,
                    startY,
                    margin: { left: 160 },
                    tableWidth: 110,
                    theme: "striped",
                    styles: { fontSize: 7, cellPadding: 2 },
                    headStyles: {
                        fillColor: [63, 81, 181],
                        textColor: 255,
                        fontStyle: "bold"
                    },
                    columnStyles: {
                        0: { cellWidth: 75 },
                        1: { cellWidth: 25 }
                    }
                });

                finalSummaryY = Math.max(finalSummaryY, doc.lastAutoTable.finalY);
            }

            doc.setFontSize(11);
            doc.text("Subject Registred Students Details", 14, finalSummaryY + 10);

            const tableHeaders = [["Sr No.", "PRN", "Student Name", "Subject Name", "Standard", "Division"]];
            const tableRows = this.filteredStudents.map((stu, index) => [
                index + 1,
                stu.learner_prn || 'N/A',
                stu.learner_name || 'N/A',
                stu.subject_names || 'N/A',
                stu.standard || 'N/A',
                stu.division || 'N/A'
            ]);

            doc.autoTable({
                head: tableHeaders,
                body: tableRows,
                startY: finalSummaryY + 14,
                theme: "grid",
                styles: { fontSize: 7, cellPadding: 1 },
                headStyles: { fillColor: [30, 41, 59], textColor: [255, 255, 255], fontStyle: "bold" },
                columnStyles: {
                    0: { cellWidth: 10 },
                    1: { cellWidth: 25 },
                    2: { cellWidth: 75 },
                    3: { cellWidth: 90 },
                    4: { cellWidth: 35 },
                    5: { cellWidth: 25 }
                }
            });

            doc.save(`Student_Subject_Report_${Date.now()}.pdf`);
        },

        showSnackbar(color, msg) {
            this.color = color;
            this.snackbar_msg = msg;
            this.snackbar = true;
        }

    }

};
</script>

<style scoped>
.unique-report-card {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
    background-color: #fafbfc !important;
}

.action-fetch-btn {
    min-width: 110px;
}

.generic-summary-container {
    border: 1px solid #e2e8f0;
    border-left: 4px solid #3f51b5;
}

.student-table>>>th {
    font-weight: 600 !important;
    background-color: #f5f7fa !important;
    color: #4a5568 !important;
}

.custom-designed-table {
    width: 100% !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
    border: 1px solid #cbd5e1 !important;
    border-radius: 6px !important;
    overflow: hidden;
    background: #fff !important;
}

.custom-designed-table>>>table {
    width: 100%;
    table-layout: fixed;
}

.custom-designed-table>>>thead tr th {
    background: #1e293b !important;
    color: white !important;
    font-size: 9.5pt;
    font-weight: 600;
    height: 44px;
    border: none;
}

.custom-designed-table>>>tbody tr {
    height: 38px;
}

.custom-designed-table>>>tbody tr:nth-child(even) {
    background: #f8fafc;
}

.custom-designed-table>>>tbody tr td {
    font-size: 9.5pt;
    color: #334155;
    padding: 8px 12px;
    border-bottom: 1px solid #e2e8f0;
}

.custom-designed-table>>>tbody tr:last-child td {
    border-bottom: none;
}

.table-row-hover:hover {
    background: #f1f5f9 !important;
}

.sr-num-col {
    color: #94a3b8;
    font-weight: 600;
}

.prn-text-col {
    font-family: Consolas, Monaco, monospace;
    color: #475569;
}

.name-text-col {
    font-weight: 600;
    color: #0f172a;
}
</style>
